import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e575cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-space-between" }
const _hoisted_2 = { class: "rank" }
const _hoisted_3 = { class: "profile" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "username", -1))
const _hoisted_5 = { class: "progress-bar" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "250 of 600", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rank:"),
  /*#__PURE__*/_createTextVNode(" Expert")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stats" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Player details"),
  /*#__PURE__*/_createElementVNode("span", null, "Games won: 13 out of 14"),
  /*#__PURE__*/_createElementVNode("span", null, "Win percentage: 92.86%"),
  /*#__PURE__*/_createElementVNode("span", null, "Tournaments won 1 out of 7"),
  /*#__PURE__*/_createElementVNode("span", null, "Win streak: 2"),
  /*#__PURE__*/_createElementVNode("span", null, "Balls potted: 142"),
  /*#__PURE__*/_createElementVNode("span", null, "Time played: 7h 31min")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    class: "user-modal"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_fa_icon, {
              icon: "user",
              size: "4x"
            }),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              style: _normalizeStyle({ width: _ctx.progress }),
              class: "progress"
            }, null, 4)
          ]),
          _hoisted_6,
          _hoisted_7
        ]),
        _hoisted_8
      ])
    ]),
    _: 1
  }))
}